import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button, useMediaQuery, useTheme, } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { between } from "../style/style";
import { FInput } from "../inputs";
import { SIconButton } from "../buttons";
import { useForm } from "react-hook-form";
const ConfirmDialog = ({ isOpen, onClose, onConfirm, loading = false, actionText = "", screenName = "", customMessage, variant = "delete", haveReason = false, }) => {
    const { t } = useTranslation(["form", "validation", "common"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { control, handleSubmit, formState: { errors }, } = useForm();
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, maxWidth: "xs", "aria-labelledby": "confirm-dialog-title", onKeyDown: (e) => {
            if (e.key === "Enter" && onConfirm) {
                onConfirm();
            }
        } },
        React.createElement(DialogTitle, { sx: Object.assign(Object.assign({}, between), { py: 1 }), id: "confirm-dialog-title" },
            React.createElement(Typography, { variant: "h6", component: "span", color: "text.primary" }, actionText && screenName
                ? `${actionText} ${screenName}`
                : t("common:dialog.confirmAction")),
            React.createElement(SIconButton, { onClick: onClose, "aria-label": "Close", title: "Close", colorVariant: "primary", showBackground: false },
                React.createElement(Icon, { icon: "mingcute:close-line", width: "18", height: "18" }))),
        React.createElement(DialogContent, null,
            React.createElement(Box, { sx: { display: "flex", flexDirection: "column", gap: 2, mt: 1 } },
                React.createElement(Typography, { variant: "subtitle2", color: "text.secondary" },
                    customMessage
                        ? customMessage
                        : variant === "delete"
                            ? t("common:dialog.confirmMessage", { actionText, screenName })
                            : t("common:dialog.discardChangesText"),
                    t("common:dialog.irreversibleWarning")),
                haveReason && (React.createElement(FInput, { name: "comment", control: control, label: t("common:labels.reason"), multiline: true, minRows: 3, 
                    // placeholder="Write your reason..."
                    size: "small", fullWidth: true })))),
        React.createElement(DialogActions, { sx: {
                py: isMobile ? 2 : 3,
                mb: isMobile ? 1 : 0,
                gap: isMobile ? 0.5 : 0.5,
            } },
            React.createElement(Button, { onClick: handleSubmit((data) => {
                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(data.comment);
                }), variant: "contained", color: variant === "delete"
                    ? "error"
                    : variant === "warning"
                        ? "warning"
                        : variant === "success"
                            ? "success"
                            : variant === "reopen"
                                ? "inherit"
                                : "primary", loading: loading, type: "submit", autoFocus: true }, variant === "delete"
                ? t("common:actions.delete")
                : variant === "discard"
                    ? t("common:actions.discard")
                    : variant === "warning"
                        ? t("common:actions.deny")
                        : variant === "success"
                            ? t("common:actions.approve")
                            : variant === "reopen"
                                ? t("common:actions.reopen")
                                : t("common:actions.confirm")),
            React.createElement(Button, { onClick: onClose, color: "inherit", variant: "outlined" }, t("common:actions.cancel")))));
};
export default ConfirmDialog;
